// extracted by mini-css-extract-plugin
var _1 = "InaccessibleMentionNotice-module__animateUploadProgressBarWidth--Zy7j2";
var _2 = "InaccessibleMentionNotice-module__animatedBackground--tYKUx";
var _3 = "InaccessibleMentionNotice-module__button--ztieI";
var _4 = "InaccessibleMentionNotice-module__error--GKzwC";
var _5 = "InaccessibleMentionNotice-module__icon--bLZCV";
var _6 = "InaccessibleMentionNotice-module__title--LKh8e";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "button", _4 as "error", _5 as "icon", _6 as "title" }
